import moment from "moment-timezone";
import { allTimezones } from "react-timezone-select";

// Подписи с названиями стран, чтобы поиск по "china", "vietnam", "япония" и т.д. находил зоны
const _tzLabels = {
  ...allTimezones,
  "Pacific/Midway": "USA, United States (Midway Island, Samoa)",
  "Pacific/Honolulu": "USA, United States (Hawaii)",
  "America/Juneau": "USA, United States (Alaska)",
  "America/Boise": "USA, United States (Mountain Time)",
  "America/Chicago": "USA, United States (Central Time)",
  "America/Detroit": "USA, United States (Eastern Time)",
  "America/Los_Angeles": "USA, United States (Pacific Time)",
  "America/New_York": "USA, United States (New York)",
  "America/Regina": "Canada (Saskatchewan, Regina)",
  "America/St_Johns": "Canada (Newfoundland, St. John's)",
  "America/Toronto": "Canada (Toronto, Ontario)",
  "America/Vancouver": "Canada (Vancouver)",
  "America/Dawson": "Canada (Dawson, Yukon)",
  "America/Mexico_City": "Mexico (Mexico City, Guadalajara, Monterrey)",
  "America/Bogota": "Colombia, Peru, Ecuador (Bogota, Lima, Quito)",
  "America/Sao_Paulo": "Brazil (Brasilia)",
  "Europe/London": "UK, United Kingdom (London, Edinburgh)",
  "Europe/Berlin": "Germany (Berlin)",
  "Europe/Amsterdam": "Netherlands (Amsterdam)",
  "Europe/Paris": "France (Paris)",
  "Europe/Rome": "Italy (Rome)",
  "Europe/Madrid": "Spain (Madrid)",
  "Europe/Brussels": "Belgium (Brussels, Copenhagen)",
  "Europe/Warsaw": "Poland (Warsaw)",
  "Europe/Prague": "Czech Republic (Prague)",
  "Europe/Bratislava": "Slovakia (Bratislava)",
  "Europe/Budapest": "Hungary (Budapest)",
  "Europe/Bucharest": "Romania (Bucharest)",
  "Europe/Sofia": "Bulgaria (Sofia)",
  "Europe/Belgrade": "Serbia, Montenegro (Belgrade)",
  "Europe/Zagreb": "Croatia (Zagreb)",
  "Europe/Ljubljana": "Slovenia (Ljubljana)",
  "Europe/Sarajevo": "Bosnia (Sarajevo)",
  "Europe/Istanbul": "Turkey (Istanbul)",
  "Europe/Moscow": "Москва (Moscow, МСК, Russia, Россия, UTC+3, GMT+3)",
  "Europe/Kaliningrad": "Калининград (Kaliningrad, Russia, Россия, UTC+2, GMT+2)",
  "Europe/Samara": "Самара (Samara, Russia, Россия, UTC+4, GMT+4)",
  "Europe/Minsk": "Минск (Minsk, Беларусь, Belarus, UTC+3)",
  "Europe/Kyiv": "Киев (Kyiv, Kiev, Украина, Ukraine, UTC+2, UTC+3)",
  "Europe/Riga": "Рига (Riga, Латвия, Latvia, UTC+2)",
  "Europe/Vilnius": "Вильнюс (Vilnius, Литва, Lithuania, UTC+2)",
  "Europe/Tallinn": "Таллин (Tallinn, Эстония, Estonia, UTC+2)",
  "Europe/Helsinki": "Finland, Estonia, Ukraine (Helsinki, Kyiv, Riga, Tallinn, Vilnius)",
  "Africa/Cairo": "Egypt (Cairo)",
  "Asia/Jerusalem": "Israel (Jerusalem)",
  "Asia/Dubai": "UAE, United Arab Emirates (Dubai, Abu Dhabi, Muscat)",
  "Asia/Baku": "Baku (Azerbaijan, Georgia, Tbilisi, Yerevan, UTC+4)",
  "Asia/Bishkek": "Kyrgyzstan (Bishkek)",
  "Asia/Yerevan": "Ереван (Yerevan, Армения, Armenia, UTC+4)",
  "Asia/Karachi": "Pakistan, Uzbekistan (Islamabad, Karachi, Tashkent)",
  "Asia/Tashkent": "Ташкент (Tashkent, Узбекистан, Uzbekistan, UTC+5)",
  "Asia/Kolkata": "India (Mumbai, New Delhi, Kolkata, Chennai)",
  "Asia/Kathmandu": "Nepal (Kathmandu)",
  "Asia/Dhaka": "Kazakhstan, Bangladesh (Astana, Dhaka)",
  "Asia/Almaty": "Алматы (Almaty, Алмата, Казахстан, Kazakhstan, UTC+5)",
  "Asia/Yekaterinburg": "Екатеринбург (Ekaterinburg, Yekaterinburg, Екат, Russia, Россия, UTC+5, GMT+5)",
  "Asia/Omsk": "Омск (Omsk, Russia, Россия, UTC+6, GMT+6)",
  "Asia/Rangoon": "Myanmar (Yangon Rangoon)",
  "Asia/Bangkok": "Thailand, Vietnam, Indonesia (Bangkok, Hanoi, Jakarta)",
  "Asia/Ho_Chi_Minh": "Vietnam (Ho Chi Minh City)",
  "Asia/Saigon": "Vietnam (Ho Chi Minh City)",
  "Asia/Krasnoyarsk": "Красноярск (Krasnoyarsk, Russia, Россия, UTC+7, GMT+7)",
  "Asia/Irkutsk": "Иркутск (Irkutsk, Russia, Россия, UTC+8, GMT+8)",
  "Asia/Yakutsk": "Якутск (Yakutsk, Russia, Россия, UTC+9, GMT+9)",
  "Asia/Shanghai": "China (Beijing, Shanghai, Hong Kong, Chongqing, Urumqi)",
  "Asia/Hong_Kong": "China (Hong Kong)",
  "Asia/Kuala_Lumpur": "Malaysia, Singapore (Kuala Lumpur, Singapore)",
  "Asia/Taipei": "Taiwan (Taipei)",
  "Asia/Seoul": "South Korea (Seoul)",
  "Asia/Tokyo": "Japan (Tokyo, Osaka, Sapporo, Япония)",
  "Asia/Vladivostok": "Владивосток (Vladivostok, Russia, Россия, UTC+10, GMT+10)",
  "Asia/Magadan": "Магадан (Magadan, Russia, Россия, UTC+11, GMT+11)",
  "Asia/Kamchatka": "Камчатка (Kamchatka, Petropavlovsk, Russia, Россия, UTC+12, GMT+12)",
  "Australia/Sydney": "Australia (Sydney, Melbourne, Canberra)",
  "Australia/Perth": "Australia (Perth)",
  "Pacific/Auckland": "New Zealand (Auckland, Wellington)",
};

// Библиотека оставляет одну опцию на offset; для UTC+9 нужна Япония (Tokyo), а не Корея (Seoul) — задаём порядок ключей
const timezoneLabelsWithCountries = Object.keys(_tzLabels)
  .sort((a, b) => {
    if (a === "Asia/Seoul" && b === "Asia/Tokyo") return 1;
    if (a === "Asia/Tokyo" && b === "Asia/Seoul") return -1;
    return a.localeCompare(b);
  })
  .reduce((acc, k) => ({ ...acc, [k]: _tzLabels[k] }), {});

// В dropdown и инпуте показываем только латиницу; поиск по searchTerms (русский + латиница) не трогаем
function getShortDisplayNameLatin(fullLabelPart) {
  if (!fullLabelPart) return fullLabelPart;
  const hasCyrillic = (s) => /[а-яёА-ЯЁ]/.test(s);
  if (!fullLabelPart.includes(" (")) return fullLabelPart;
  const before = fullLabelPart.split(" (")[0].trim();
  const inParens = fullLabelPart.replace(/^[^(]*\(([^)]*)\).*/, "$1").trim();
  if (hasCyrillic(before) && inParens) {
    const firstToken = inParens.split(",")[0].trim();
    return firstToken || before;
  }
  return before;
}

// Свои опции: сначала РФ/СНГ (Russia, Россия), потом по offset — чтобы в списке не шла первой Америка
function buildTimezoneOptionsSorted() {
  const raw = [];
  Object.entries(timezoneLabelsWithCountries).forEach(([value, labelPart]) => {
    try {
      const offsetMin = moment().tz(value).utcOffset();
      const offset = offsetMin / 60;
      const sign = offset >= 0 ? "+" : "-";
      const hr = Math.floor(Math.abs(offset));
      const min = Math.round((Math.abs(offset) % 1) * 60);
      const offsetStr = min ? `${sign}${hr}:${String(min).padStart(2, "0")}` : `${sign}${hr}:00`;
      const shortName = getShortDisplayNameLatin(labelPart);
      const label = `(UTC${offsetStr}) ${shortName}`;
      const text = (labelPart || "").toLowerCase();
      const isRussia = text.includes("russia") || text.includes("россия");
      const continent = value.split("/")[0];
      const skipContinent = !continent || /^Etc$/i.test(continent) || /^UTC/i.test(continent);
      const searchTerms = skipContinent ? labelPart : [labelPart, continent].filter(Boolean).join(" ");
      raw.push({ value, label, offset: offsetMin, searchTerms, isRussia });
    } catch (e) {
      // пропускаем зоны, которые moment не знает
    }
  });
  raw.sort((a, b) => {
    if (a.isRussia && !b.isRussia) return -1;
    if (!a.isRussia && b.isRussia) return 1;
    return a.offset - b.offset;
  });
  return raw.map(({ value, label, offset, searchTerms }) => ({ value, label, offset, searchTerms }));
}

const timezoneOptionsSorted = buildTimezoneOptionsSorted();

// Нормализация поиска: trim + lowercase, чтобы "  Russia  " и "RUSSIA" находили опции
function filterTimezoneOption(option, inputValue) {
  const term = (inputValue || "").trim().toLowerCase();
  if (!term) return true;
  const data = option?.data || option;
  const label = (data?.label || "").toLowerCase();
  const searchTerms = (data?.searchTerms || "").toLowerCase();
  return label.includes(term) || searchTerms.includes(term);
}

export { timezoneLabelsWithCountries, timezoneOptionsSorted, filterTimezoneOption };
